(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-aos-script"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
        AOS.init();
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-fullbleed-image"] && !Shopify.designMode) return;
  try {
    const mobileQuery = window.matchMedia('(max-width: 767px)');

    function pickSrc(video) {
      const { desktop, mobile } = video.dataset;
      return (mobileQuery.matches && mobile) ? mobile : desktop;
    }
  
    const observer = new IntersectionObserver((entries, obs) => {

      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
    
        const video = entry.target;
        const src = pickSrc(video);
    
        if (src) {
          video.src = src;
          video.load();
          video.play().catch(() => {}); // ignore autoplay rejections
        }
    
        obs.unobserve(video);
      });
    }, { rootMargin: '200px' }); // start loading slightly before it's visible
  
    document.querySelectorAll('video[data-desktop]').forEach(v => observer.observe(v));


    mobileQuery.addEventListener('change', () => {
      document.querySelectorAll('video[data-desktop]').forEach(video => {
        if (!video.getAttribute('src')) return; // not loaded yet, observer will handle it

        const newSrc = pickSrc(video);
        if (video.getAttribute('src') === newSrc) return; // no change needed

        const time = video.currentTime;
        const wasPlaying = !video.paused;
        video.src = newSrc;
        video.load();
        video.currentTime = time;
        if (wasPlaying) video.play().catch(() => {});
      });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-hero"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', (event) => {
  
    const muteButtons = document.querySelectorAll('.ss-hero .mute-unmute-btn .mute-icon');
    
    muteButtons.forEach((button) => {
      button.addEventListener('click', function() {
        this.style.display = 'none';
        muteUnmutebtn = this.closest('.mute-unmute-btn');
        muteUnmutebtn.querySelector('.unmute-icon').style.display = '';

        mediaPlaceholder = muteUnmutebtn.closest('.media-placeholder');
        mediaVideo = mediaPlaceholder.querySelector('video');
        mediaVideo.muted = !mediaVideo.muted;
      });
    });

    const unmuteButtons = document.querySelectorAll('.ss-hero .mute-unmute-btn .unmute-icon');
    
    unmuteButtons.forEach((button) => {
      button.addEventListener('click', function() {
        this.style.display = 'none';
        muteUnmutebtn = this.closest('.mute-unmute-btn');
        muteUnmutebtn.querySelector('.mute-icon').style.display = '';

        mediaPlaceholder = muteUnmutebtn.closest('.media-placeholder');
        mediaVideo = mediaPlaceholder.querySelector('video');
        mediaVideo.muted = !mediaVideo.muted;
      });
    });

    const pauseButtons = document.querySelectorAll('.ss-hero .play-pause-btn .pause-icon');
    
    pauseButtons.forEach((button) => {
      button.addEventListener('click', function() {
        this.style.display = 'none';
        playPausebtn = this.closest('.play-pause-btn');
        playPausebtn.querySelector('.play-icon').style.display = '';

        mediaPlaceholder = playPausebtn.closest('.media-placeholder');
        mediaPlaceholder.querySelector('video').pause();
      });
    });

    const playButtons = document.querySelectorAll('.ss-hero .play-pause-btn .play-icon');
    
    playButtons.forEach((button) => {
      button.addEventListener('click', function() {
        this.style.display = 'none';
        playPausebtn = this.closest('.play-pause-btn');
        playPausebtn.querySelector('.pause-icon').style.display = '';

        mediaPlaceholder = playPausebtn.closest('.media-placeholder');
        mediaPlaceholder.querySelector('video').play();
      });
    });
    
  });
  } catch(e) { console.error(e); }
})();

})();
